import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export default function PageLoader() {
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const t = setTimeout(() => setLoading(false), 600);
    return () => clearTimeout(t);
  }, [location.pathname]);

  if (!loading) return null;

  return (
    <div
      data-testid="page-loader"
      className="fixed top-0 left-0 right-0 z-[100] pointer-events-none"
    >
      <div className="h-1 bg-gradient-to-r from-[#FFE4E8] via-[#1B4332] to-[#E8F5E9] animate-loader-bar origin-left" />
      <style>{`
        @keyframes loaderBar {
          0% { transform: scaleX(0); }
          50% { transform: scaleX(0.7); }
          100% { transform: scaleX(1); }
        }
        .animate-loader-bar { animation: loaderBar 0.6s cubic-bezier(0.4, 0, 0.2, 1) forwards; }
      `}</style>
    </div>
  );
}

export function FullPageLoader() {
  return (
    <div data-testid="full-page-loader" className="fixed inset-0 z-[200] bg-[#FFFCF2] flex items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <div className="w-14 h-14 rounded-2xl bg-[#1B4332] flex items-center justify-center animate-pulse">
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
            <path d="M4 6h12a4 4 0 010 8H4V6z" stroke="#E8F5E9" strokeWidth="2.5" strokeLinejoin="round"/>
            <path d="M4 14h14a4 4 0 010 8H4v-8z" stroke="#E8F5E9" strokeWidth="2.5" strokeLinejoin="round"/>
          </svg>
        </div>
        <div className="text-sm font-semibold text-black/60 tracking-widest uppercase">Loading</div>
      </div>
    </div>
  );
}
